/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// eslint-disable-next-line import/extensions
import { signOut } from 'aws-amplify/auth';
import { SIGN_OUT_USER } from '#constants/actionTypes.js';
import {
  selectAuthUserIsSet,
  selectAuthUserIsActive,
  selectAuthUserOrgIsActive,
} from '#selectors/entities/users.js';
import { signOutUser } from '#actions/users/users.js';

const signOutMiddleware = store => next => action => {
  const { type } = action;
  if (type === SIGN_OUT_USER) {
    signOut();
    localStorage.clear();
  } else {
    const state = store.getState();
    const authUserIsSet = selectAuthUserIsSet(state);
    if (authUserIsSet) {
      const authUserIsActive = selectAuthUserIsActive(state);
      const authUserOrgIsActive = selectAuthUserOrgIsActive(state);
      if (!authUserIsActive || !authUserOrgIsActive) {
        store.dispatch(signOutUser());
      }
    }
  }
  return next(action);
};

export default signOutMiddleware;
